import React from "react";

export default function ShippingReturns() {
    return (
        <div className="min-h-screen bg-white px-6 md:px-20 py-20">
            <h1 className="font-display text-4xl mb-8">Shipping & Returns</h1>

            <div className="max-w-3xl text-sm text-gray-600 space-y-6 font-sans leading-relaxed">
                <p>
                    We offer worldwide shipping on all AURÉNE orders. All purchases are
                    carefully packaged to ensure they arrive in perfect condition.
                </p>

                <h2 className="text-lg font-semibold text-black">Shipping</h2>
                <p>
                    Orders are processed within 1–2 business days. Delivery typically
                    takes 3–7 business days depending on your location.
                </p>

                <h2 className="text-lg font-semibold text-black">Returns</h2>
                <p>
                    If you are not completely satisfied, you may return your item within
                    14 days of delivery. Items must be unworn, unused, and in original
                    packaging.
                </p>

                <p>
                    To initiate a return, please contact our support team with your order
                    number.
                </p>
            </div>
        </div>
    );
}